/**
 * Converts the given object to a base64 encoded string using btoa.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
 */
const convertObjectToBase64 = (obj: $Object): string =>
  btoa(JSON.stringify(obj));

export default convertObjectToBase64;
